// src/App.js
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Admin from "./pages/Admin";
import ConsentBanner from "./consent/ConsentBanner";
import FloatingCallButton from "./components/FloatingCallButton";

const ADMIN_HASH = "#34DQKMme41";

// Optional tiny debug banner. Set ?debug=1 in the URL to show it.
function DebugBar({ page }) {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setOn(params.get("debug") === "1");
  }, []);
  if (!on) return null;
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "rgba(17,24,39,0.9)",
        color: "white",
        fontSize: 12,
        padding: "6px 10px",
        zIndex: 1000,
      }}
    >
      hash: <b>{window.location.hash || "(none)"}</b> | page: <b>{page}</b>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState("home");

  // HASH ROUTING (runs on mount + when hash changes)
  useEffect(() => {
    const applyHash = () => {
      const { hash } = window.location;
      if (hash === ADMIN_HASH) {
        setPage("admin");
      } else if (hash === "#gallery") {
        setPage("gallery");
      } else {
        setPage("home");
      }
    };
    applyHash();
    window.addEventListener("hashchange", applyHash);
    return () => window.removeEventListener("hashchange", applyHash);
  }, []);

  // SCROLL TO TOP (never clears the admin hash)
  useEffect(() => {
    setTimeout(() => {
      const { hash } = window.location;
      if (hash && hash !== ADMIN_HASH) {
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
      }
      window.scrollTo({ top: 0, behavior: "auto" });
    }, 0);
  }, [page]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 text-gray-900">
      <Navbar page={page} setPage={setPage} />
      {page === "home" && <Home onOpenGallery={() => setPage("gallery")} />}
      {page === "gallery" && <Gallery setPage={setPage} />}
      {page === "admin" && <Admin />}
      <ConsentBanner />
      <footer className="border-t bg-white/60">
        <div className="max-w-6xl mx-auto px-4 py-6 text-sm text-gray-600 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center justify-between">
          <span>© {new Date().getFullYear()} Manu Pro Detailing</span>
          <span className="opacity-80">Județul Timiș</span>
        </div>
      </footer>
      <FloatingCallButton phone="+40762705175" label="Sună acum" />
      <DebugBar page={page} />
    </div>
  );
}
